import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Deutsch, English, Español } from '../../../Constant';
import { USER_LANG_PREF_KEY } from '../../../Hooks/useCountryLanguage';

// Sprach-Code (i18next) -> Anzeige-Konfiguration (Flagge + Label).
const LANG_DISPLAY = {
  en: { flag: 'us', label: English, suffix: ' (US)' },
  du: { flag: 'de', label: Deutsch },
  es: { flag: 'es', label: Español },
  'pt-BR': { flag: 'br', label: 'Português', suffix: ' (Brasil)' },
};

const Language = () => {
  const [langdropdown, setLangdropdown] = useState(false);
  const { i18n } = useTranslation();
  const [selected, setSelected] = useState(
    localStorage.getItem('i18nextLng') || i18n.language
  );

  // Hinweis: Initiale Sprache liefert i18next-browser-languagedetector
  // anhand von navigator.language / localStorage. Country-Wechsel via
  // useCountryLanguage in src/Layout/Layout.jsx hat höhere Priorität.

  // Hält selected synchron, wenn i18n von außen umgeschaltet wird
  // (z.B. durch useCountryLanguage anhand des URL-Country-Segments).
  useEffect(() => {
    const onLangChange = (lng) => setSelected(lng);
    i18n.on('languageChanged', onLangChange);
    return () => i18n.off('languageChanged', onLangChange);
  }, [i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    // Manuelle Userwahl persistieren -- useCountryLanguage respektiert das
    // dann gegenüber URL-Country und Browser-Sprache.
    localStorage.setItem(USER_LANG_PREF_KEY, lng);
    setSelected(lng);
  };

  const toggleDropdown = () => setLangdropdown((s) => !s);

  const current = LANG_DISPLAY[selected] || LANG_DISPLAY['du'];

  return (
    <li className='language-nav'>
      <div className={`translate_wrapper ${langdropdown ? 'active' : ''}`}>
        <div className='current_lang'>
          <div className='lang' onClick={toggleDropdown}>
            <i className={`flag-icon flag-icon-${current.flag}`}></i>
            <span className='lang-txt'>{selected}</span>
          </div>
        </div>
        <div className={`more_lang ${langdropdown ? 'active' : ''}`}>
          {Object.entries(LANG_DISPLAY).map(([code, info]) => (
            <div
              key={code}
              className={`lang${selected === code ? ' active' : ''}`}
              onClick={() => {
                changeLanguage(code);
                setLangdropdown(false);
              }}
            >
              <i className={`flag-icon flag-icon-${info.flag}`}></i>
              <span className='lang-txt'>
                {info.label}
                {info.suffix ? <span>{info.suffix}</span> : null}
              </span>
            </div>
          ))}
        </div>
      </div>
    </li>
  );
};

export default Language;
